import { fromJS } from 'immutable';
import _ from 'lodash';
import * as mortgagelenderActions from '../actions/mortgagelender';
import { SUCCESS, START, ERROR } from '../actions/global';
import { fetchingState, defaultPageSize } from '@constants';

const initialStats = {
  fields: {},
  searchOptions: {},
  mortgagelenderList: {
    pageSize: defaultPageSize,
    sortModel: [],
    currentPage: 0,
  },
  tagList: {},
  mortgagelender: {},
  notes: {},
  properties: {},
  events: { data: [], state: null },
  lenders: { data: [], state: null },
};

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    case mortgagelenderActions.MORTGAGELENDER_SEARCH_OPTIONS_FETCH_START:
      return state.setIn(['searchOptions', 'state'], fetchingState.FETCHING);
    case mortgagelenderActions.MORTGAGELENDER_SEARCH_OPTIONS_FETCH_SUCCESS:
      let newState = state.setIn(
        ['searchOptions', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['searchOptions', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case mortgagelenderActions.MORTGAGELENDER_SEARCH_OPTIONS_FETCH_ERROR:
      return state.setIn(['searchOptions', 'state'], fetchingState.ERROR);

    case mortgagelenderActions.MORTGAGELENDER_FIELDS_FETCH_START:
      return state.setIn(['fields', 'state'], fetchingState.FETCHING);
    case mortgagelenderActions.MORTGAGELENDER_FIELDS_FETCH_SUCCESS:
      newState = state.setIn(['fields', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['fields', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case mortgagelenderActions.MORTGAGELENDER_FIELDS_FETCH_ERROR:
      return state.setIn(['fields', 'state'], fetchingState.ERROR);

    case mortgagelenderActions.MORTGAGELENDER_TAGS_FETCH_START:
      return state.setIn(['tagList', 'state'], fetchingState.FETCHING);
    case mortgagelenderActions.MORTGAGELENDER_TAGS_FETCH_SUCCESS:
      newState = state.setIn(['tagList', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['tagList', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case mortgagelenderActions.MORTGAGELENDER_TAGS_FETCH_ERROR:
      return state.setIn(['tagList', 'state'], fetchingState.ERROR);

    case mortgagelenderActions.MORTGAGELENDER_SEARCH_START:
      return state.setIn(
        ['mortgagelenderList', 'state'],
        fetchingState.FETCHING,
      );
    case mortgagelenderActions.MORTGAGELENDER_SEARCH_SUCCESS:
      newState = state.setIn(
        ['mortgagelenderList', 'state'],
        fetchingState.LOADED,
      );
      newState = newState.setIn(
        ['mortgagelenderList', 'totalCount'],
        action.data && action.data.totalMortageLender
          ? action.data.totalMortageLender.mortgageLenderCount
          : 0,
      );
      return newState.setIn(
        ['mortgagelenderList', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case mortgagelenderActions.MORTGAGELENDER_SEARCH_ERROR:
      return state.setIn(['mortgagelenderList', 'state'], fetchingState.ERROR);

    case mortgagelenderActions.MORTGAGELENDER_CHANGE_CURRENT_PAGE:
      return state.setIn(['mortgagelenderList', 'currentPage'], action.data);
    case mortgagelenderActions.MORTGAGELENDER_CHANGE_PAGE_SIZE:
      return state.setIn(['mortgagelenderList', 'pageSize'], action.data);
    case mortgagelenderActions.MORTGAGELENDER_CHANGE_SORT_MODEL:
      return state.setIn(
        ['mortgagelenderList', 'sortModel'],
        fromJS(action.data),
      );

    case mortgagelenderActions.MORTGAGELENDER_FETCH_START:
      return state.setIn(['mortgagelender', 'state'], fetchingState.FETCHING);
    case mortgagelenderActions.MORTGAGELENDER_FETCH_SUCCESS:
      newState = state.setIn(['mortgagelender', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['mortgagelender', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );
    case mortgagelenderActions.MORTGAGELENDER_FETCH_ERROR:
      return state.setIn(['mortgagelender', 'state'], fetchingState.ERROR);

    case mortgagelenderActions.MORTGAGELENDER_NOTES_FETCH_START:
      return state.setIn(['notes', 'state'], fetchingState.FETCHING);
    case mortgagelenderActions.MORTGAGELENDER_NOTES_FETCH_SUCCESS:
      newState = state.setIn(['notes', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['notes', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case mortgagelenderActions.MORTGAGELENDER_NOTES_FETCH_ERROR:
      return state.setIn(['notes', 'state'], fetchingState.ERROR);

    case mortgagelenderActions.MORTGAGELENDER_PROPERTIES_FETCH_START:
      return state.setIn(['properties', 'state'], fetchingState.FETCHING);
    case mortgagelenderActions.MORTGAGELENDER_PROPERTIES_FETCH_SUCCESS:
      newState = state.setIn(['properties', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['properties', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case mortgagelenderActions.MORTGAGELENDER_PROPERTIES_FETCH_ERROR:
      return state.setIn(['properties', 'state'], fetchingState.ERROR);

    case mortgagelenderActions.MORTGAGELENDER_UPDATE_START:
      return state.setIn(['mortgagelender', 'state'], fetchingState.SAVING);
    case mortgagelenderActions.MORTGAGELENDER_UPDATE_ERROR:
      return state.setIn(['mortgagelender', 'state'], fetchingState.ERROR);
    case mortgagelenderActions.MORTGAGELENDER_UPDATE_SUCCESS:
      newState = state.setIn(['mortgagelender', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['mortgagelender', 'data'],
        fromJS(action.data.results[0]),
      );
    case mortgagelenderActions.MORTGAGELENDER_RESET_DATA:
      return state.setIn(['mortgagelender'], fromJS({}));
    case mortgagelenderActions.MORTGAGELENDER_CREATE[START]:
      return state.setIn(['mortgagelender', 'state'], fetchingState.SAVING);
    case mortgagelenderActions.MORTGAGELENDER_CREATE[SUCCESS]:
      newState = state.setIn(['mortgagelender', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['mortgagelender', 'data'],
        fromJS(action.data.results[0]),
      );
    case mortgagelenderActions.MORTGAGELENDER_CREATE[ERROR]:
      return state.setIn(['mortgagelender', 'state'], fetchingState.ERROR);
    case mortgagelenderActions.MORTGAGELENDER_VALIDATE_SUCCESS:
      return state.setIn(
        ['mortgagelender', 'data'],
        fromJS(action.data.results[0]),
      );

    case mortgagelenderActions.MORTGAGELENDER_NOTE_ADD_SUCCESS:
      let newNotes = state.getIn(['notes', 'data']).toJS();
      newNotes = newNotes.concat(action.data.results);
      return state.setIn(['notes', 'data'], fromJS(newNotes));

    case mortgagelenderActions.MORTGAGELENDER_NOTE_DELETE_SUCCESS:
      newNotes = state.getIn(['notes', 'data']).toJS();
      newNotes = newNotes.filter(n => n.noteID !== action.noteId);
      return state.setIn(['notes', 'data'], fromJS(newNotes));

    case mortgagelenderActions.MORTGAGELENDER_NOTE_UPDATE_SUCCESS:
      newNotes = state.getIn(['notes', 'data']).toJS();
      return state.setIn(['notes', 'data'], fromJS(newNotes));

    // EVENTS
    case mortgagelenderActions.LENDER_EVENTS_FETCH[START]: {
      return state
        .setIn(['events', 'data'], fromJS([]))
        .setIn(['events', 'state'], fetchingState.FETCHING);
    }
    case mortgagelenderActions.LENDER_EVENTS_FETCH[SUCCESS]: {
      return state
        .setIn(['events', 'state'], fetchingState.LOADED)
        .setIn(['events', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case mortgagelenderActions.LENDER_EVENTS_FETCH[ERROR]: {
      return state.setIn(['events', 'state'], fetchingState.ERROR);
    }
    case mortgagelenderActions.LENDER_EVENT_DELETE[SUCCESS]: {
      return state.setIn(
        ['events', 'data'],
        fromJS(
          state
            .getIn(['events', 'data'])
            .toJS()
            .filter(e => e.eventID !== action.eventID),
        ),
      );
    }
    case mortgagelenderActions.PROPERTY_MORTGAGE_LENDERS_FETCH[START]: {
      return state
        .setIn(['lenders', 'data'], fromJS([]))
        .setIn(['lenders', 'state'], fetchingState.FETCHING);
    }
    case mortgagelenderActions.PROPERTY_MORTGAGE_LENDERS_FETCH[SUCCESS]: {
      return state
        .setIn(['lenders', 'state'], fetchingState.LOADED)
        .setIn(['lenders', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case mortgagelenderActions.PROPERTY_MORTGAGE_LENDERS_FETCH[ERROR]: {
      return state.setIn(['lenders', 'state'], fetchingState.ERROR);
    }

    default:
      return state;
  }
};
